export default __webpack_public_path__ + "static/media/GUALTIERI-33.29a5f0b3.webp";